import clsx from "clsx";
import SensorStatusItemStyle from "./css/SensorStatusItem.module.css";
import { ComponentPropsWithRef, forwardRef } from "react";

type SensorStatusItemProps = ComponentPropsWithRef<"div"> & {
    statusCnt: number;
    codeName: string;
    color?: string;
    selected?: boolean;
    codeId?: string; // codeId 타입 추가
}

const SensorStatusItem = forwardRef<HTMLDivElement, SensorStatusItemProps>(
    ({ statusCnt, codeName, color = "black", selected = false, codeId, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={clsx(
                    SensorStatusItemStyle.item,
                )}
                {...props}
            >
                <span className={SensorStatusItemStyle.count} style={{ color }}>{statusCnt}</span>
                <span className={SensorStatusItemStyle.text}>{codeName}</span>
            </div>
        )
    }
);

export default SensorStatusItem;
export type { SensorStatusItemProps };